module.exports = __webpack_public_path__ + "static/img/ci.6c40978.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pantos/ci.png
// module id = v+GS
// module chunks = 0